module.exports = __webpack_public_path__ + "media/step_1_ru.0ffc8a1a.mp3";